import { Styles } from "../../config"

const styles = {
	container: {
		width: "100%",
		height: "50px",
		justifyContent: "center",
		alignItems: "center",
		background: "linear-gradient(135deg, #7FC2FF 0%, #6C63FF 100%)"
	},

	textContainer: {
		width: "100%",
		justifyContent: "center",
		alignItems: "center"
	},

	text: {
		fontSize: { zero: "0.9rem", xs2: "1rem" },
		color: Styles.Color.white
	}
}

export default styles
